export default __webpack_public_path__ + "static/media/HDFC-Life-Logo.d22de03c.jpg";